import React from "react";
import { TextField, Grid, Typography } from "@material-ui/core";
import { ace } from "../theme";

const DestinationAddressStep = ({ value, onChange, submitted }) => (
  <div>
    <Typography variant="h5" style={{ color: ace.black, fontWeight: 700, marginBottom: 8 }}>
      Where you&apos;re moving to
    </Typography>
    <Typography variant="body2" style={{ color: ace.muted, marginBottom: 24 }}>
      Destination address — same details help us quote accurately.
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="Address line 1"
          value={value.destinationAddress1}
          onChange={(e) => onChange("destinationAddress1", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          label="Address line 2"
          value={value.destinationAddress2}
          onChange={(e) => onChange("destinationAddress2", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="City"
          value={value.destinationCity}
          onChange={(e) => onChange("destinationCity", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="State"
          value={value.destinationState}
          onChange={(e) => onChange("destinationState", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="PIN code"
          value={value.destinationPincode}
          onChange={(e) => onChange("destinationPincode", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="Country"
          value={value.destinationCountry}
          onChange={(e) => onChange("destinationCountry", e.target.value)}
          placeholder="India"
          disabled={submitted}
        />
      </Grid>
    </Grid>
  </div>
);

export default DestinationAddressStep;
